(() => {
  'use strict';
  // Cookie choices panel for Microsoft Clarity (follow-the-law rule, 2 November 2026).
  // It records the visitor's analytics choice with Shopify's Customer Privacy API;
  // assets/vunro-clarity.js listens for that change and starts or stops Clarity.
  const open = document.querySelector('.vunro-cookie-choices__open');
  const dialog = document.getElementById('vunro-cookie-choices');
  if (!open || !dialog || typeof dialog.showModal !== 'function') return;
  const status = dialog.querySelector('.vunro-cookie-choices__status');
  function rule() {
    try { return JSON.parse(document.getElementById('vunro-consent-rule').textContent); } catch (_) { return null; }
  }
  // Same rule as assets/vunro-clarity.js: unknown or unlisted locations need an explicit yes.
  function recordUnlessNo() {
    const consentRule = rule();
    let code = '';
    try { code = window.Shopify?.customerPrivacy?.getRegion?.(); } catch (_) { code = ''; }
    if (!consentRule || typeof code !== 'string' || !/^[A-Z]{2}[A-Z0-9]{0,3}$/.test(code)) return false;
    const country = code.slice(0, 2);
    if (consentRule.askFirstSubdivisions.includes(code)) return false;
    if (consentRule.subdivisionNeeded.includes(country) && code.length === 2) return false;
    return consentRule.recordUnlessNo.includes(country);
  }
  function show() {
    const mode = recordUnlessNo() ? 'record' : 'ask';
    dialog.querySelectorAll('[data-vunro-mode]').forEach(node => { node.hidden = node.dataset.vunroMode !== mode; });
    dialog.querySelectorAll('[data-record-label]').forEach(node => {
      node.textContent = mode === 'record' ? node.dataset.recordLabel : node.dataset.askLabel;
    });
    status.textContent = '';
    dialog.showModal();
  }
  function save(allow) {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.setTrackingConsent !== 'function') {
      status.textContent = 'Sorry, your choice could not be saved. Please try again in a moment.';
      return;
    }
    privacy.setTrackingConsent({ analytics: allow }, () => {
      status.textContent = allow
        ? 'Saved: we may record your visit. You can change this here at any time.'
        : 'Saved: we will not record your visit. You can change this here at any time.';
    });
  }
  open.hidden = false;
  open.addEventListener('click', show);
  dialog.addEventListener('click', event => {
    const button = event.target.closest('[data-vunro-choice]');
    if (event.target === dialog || button?.dataset.vunroChoice === 'close') { dialog.close(); return; }
    if (button) save(button.dataset.vunroChoice === 'yes');
  });
})();
